export default __webpack_public_path__ + "static/media/twoplusone.986a4ff9.jpg";